import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import { selectActualShowReintegratePopup, selectIsMaster } from 'containers/App/selectors'

import Reintegration from 'components/pages/Reintegration'

import * as reItegrationActions from './actions'

const mapDispatchToProps = (dispatch) => bindActionCreators(reItegrationActions, dispatch)
const mapStateToProps = (state) => ({
  isMaster: selectIsMaster(state),
  showReintegratePopup: selectActualShowReintegratePopup(state),
})

const render = connect(mapStateToProps, mapDispatchToProps)(Reintegration)

export default withRouter(render)
